/**
 * The Google Maps script is injected at runtime by `MapProvider`, so it can be absent for
 * reasons that have nothing to do with our code: a consent manager blocking third-party
 * scripts, an ad blocker, a failed network request, or a render that beats the script's
 * `load` event. `google` is a bare global, so touching it unguarded throws a ReferenceError
 * that React cannot recover from — it unmounts the tree and the questionnaire goes blank.
 *
 * Every entry point into `google.*` must go through one of these checks first.
 */
export const isGoogleMapsLoaded = () => typeof google !== 'undefined' && Boolean(google?.maps);

/** `places` powers address autocomplete and place lookups. */
export const isGooglePlacesLoaded = () => isGoogleMapsLoaded() && Boolean(google.maps.places);

/** `geometry` powers the service-area (polygon containment) check. */
export const isGoogleGeometryLoaded = () => isGoogleMapsLoaded() && Boolean(google.maps.geometry?.poly);
